import heroImg from 'assets/icons/for-founders-hr-it-and-admins/hero1.webp'
import mobileHeroImg from 'assets/icons/for-founders-hr-it-and-admins/mobile-hero-image.png'
import founderImg from 'assets/icons/for-founders-hr-it-and-admins/founder1.webp'
import hrImg from 'assets/icons/for-founders-hr-it-and-admins/hr1.webp'
import ctoImg from 'assets/icons/for-founders-hr-it-and-admins/cto1.webp'
import adminsImg from 'assets/icons/for-founders-hr-it-and-admins/admins1.webp'
import blueTickImg from 'assets/icons/common/blue-tick-circle.svg'

export const heroSectionData = {
  title: 'Reduce your workload and automate time-consuming IT tasks',
  // subTitle: `Save hours setting up devices late at night or muddling through dozens of tools to manage your company's IT.`,
  paragraph: `Save hours setting up devices late at night or muddling through dozens of tools to manage your company's IT.`,
  btnText: 'Get ZenAdmin For Free',
  image: heroImg,
  mobileImage: mobileHeroImg,
}

export const foundersData = {
  topTitle: 'ZenAdmin For Founders',
  title: 'Stop playing the IT Admin and setting up devices late at night',
  desc: 'The ZenAdmin Platform helps you to reduce your IT workload as a founder and to get your company security compliant.',
  infoBoxes: [
    {
      title: 'Set up devices fast without manual processes',
      icon: blueTickImg,
    },
    {
      title: 'Free yourself from liability risks through IT compliance',
      icon: blueTickImg,
    },
    {
      title: 'Attract new customers who value security',
      icon: blueTickImg,
    },
  ],
  imageSrc: founderImg,
  id: 'founder',
}

export const hrData = {
  topTitle: 'ZenAdmin For HR',
  title: 'Automate your workflow and take your onboarding experience to the next level',
  desc: 'Connect your HR system like BambooHR, Humaans, Personio etc. to the ZenAdmin platform and make sure everything is set up on your new hires’ first day.',
  imageSrc: hrImg,
  id: 'hr',
  infoBoxes: [
    {
      title: 'Save valuable time by automating onboarding & offboarding processes',
      icon: blueTickImg,
    },
    {
      title: 'Boost productivity by ensuring your new hires have the right accesses from day 1',
      icon: blueTickImg,
    },
    {
      title: 'Increase employee happiness with an optimized onboarding experience',
      icon: blueTickImg,
    },
  ],
}

export const ctoData = {
  topTitle: 'ZenAdmin For CTOs',
  title: 'Stop being the go-to person for everything IT related',
  desc: 'Getting distracted by small tasks is annoying and prevents you from doing the work that matters. ZenAdmin takes the burden of small IT tasks from you by automating processes and implementing best practices.',
  imageSrc: ctoImg,
  id: 'cto',
  infoBoxes: [
    {
      title: 'Free some valuable time to work on projects that matter',
      icon: blueTickImg,
    },
    {
      title: 'Implement IT Security best-practices in your company without effort',
      icon: blueTickImg,
    },
  ],
}

export const adminData = {
  topTitle: 'ZenAdmin For IT Admins',
  title: 'Busy again with provisioning accounts instead of working on cool projects?',
  desc: 'With ZenAdmin you get back some valuable time as an IT admin to work on the things that really matter, without having to do the manual, boring tasks.',
  imageSrc: adminsImg,
  id: 'admin',
  infoBoxes: [
    {
      title: 'Work on projects that really matter without working overtime',
      icon: blueTickImg,
    },
    {
      title: 'Integrate seamlessly with existing systems to automate workflows and processes',
      icon: blueTickImg,
    },
  ],
}
